/**
 * Get the profile picture URL for an author.
 * Images are stored in /public/assets/images/authors/ with kebab-case names.
 * e.g. "Sarah Chen" -> "/assets/images/authors/sarah-chen.webp"
 */
export function getAuthorImage(authorName: string): string {
  return `/assets/images/authors/${authorName
    .toLowerCase()
    .replace(/\s+/g, '-')}.webp`;
}
